import { render, staticRenderFns } from "./finishedProduct.vue?vue&type=template&id=28722f00&scoped=true"
import script from "./finishedProduct.vue?vue&type=script&lang=js"
export * from "./finishedProduct.vue?vue&type=script&lang=js"
import style0 from "./finishedProduct.vue?vue&type=style&index=0&id=28722f00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28722f00",
  null
  
)

export default component.exports